import { Search } from "@mui/icons-material";
import { Box, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import SvgIcon from "../components/loadSvg";
import { useStyles } from "./styles";
import { serviceDescriptions } from "./utils";

const SelectService = ({ show, onSelect }) => {
  const classes = useStyles();
  const { allServices } = useSelector((state) => state.provision);
  const [searchKey, setKey] = useState("");
  const [filteredServices, setServices] = useState(allServices || []);

  useEffect(() => {
    const updatedServices = allServices.filter(
      (service) =>
        searchKey === "" ||
        service.toLowerCase().includes(searchKey.toLowerCase())
    );
    setServices(updatedServices);
  }, [searchKey, allServices]);

  return (
    <Box
      sx={{
        display: show ? "flex" : "none",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <TextField
        sx={{ width: "40%", margin: "24px 0" }}
        placeholder="search"
        label="Search"
        margin="normal"
        InputProps={{
          startAdornment: <Search />,
        }}
        variant="outlined"
        value={searchKey}
        onChange={(e) => setKey(e.target.value)}
      />
      <Box className={classes.serviceView}>
        {filteredServices.length > 0
          ? filteredServices.map((service) => (
              <Box
                key={service}
                onClick={() => onSelect(service)}
                className={classes.serviceItem}
              >
                <Box className={classes.imageView}>
                  <SvgIcon icon={service} />
                  <Typography gutterBottom={true}>
                    <b>{service}</b>
                  </Typography>
                </Box>
                <Typography sx={{ fontSize: "14px" }}>
                  {serviceDescriptions[service] ||
                    "Platform-as-a-service offering from Amazon Web"}
                </Typography>
              </Box>
            ))
          : searchKey.length > 0 && (
              <Typography>No service available</Typography>
            )}
      </Box>
    </Box>
  );
};

export default SelectService;
